import { Component, input } from '@angular/core';
import { CSSValuePipe } from '@pipes/css-value-pipe';
import type { BadgeType } from '@appTypes';

@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [ CSSValuePipe ],
  templateUrl: './badge.html',
  styleUrl: './badge.scss',
})
export class Badge {
  // Inputs
  $type = input.required<BadgeType>({ alias: 'type' });
  $text = input.required<string | number>({ alias: 'text' });
  $textFontSize = input<string>('--font-size-small', { alias: 'textFontSize' });
}
